import 'assets/css/Modal.css';
import noData from "assets/img/noData.svg";
import styles from 'assets/jss/ListStyle';
import React, {useRef, useState} from 'react';
import {makeStyles} from '@mui/styles';
import InfiniteScroll from "react-infinite-scroll-component";
//  **************** components *********************
import Grid from '@mui/material/Grid';
import Modal from 'components/Modal/Modal';
import Card from 'components/Card/Card';
import Loading from 'components/Loading/Loading';
import {Button} from '@mui/material';
import {useLogBook} from "hooks/useLogBook";
import {dataFilterListTable, destructureDataForModalCards} from "../dataStructureLogBook";
import BackToTopButton from "components/Buttons/BackToTopButton";
import ListDateTitle from "./ListDateTitle";

const useStyles = makeStyles(styles);

export default function ListTable(props) {
  const {patientId, filterChoice} = props;
  const classes = useStyles();
  const modalRef = useRef();
  const [ModalData, setModalData] = useState(null);
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading,
  } = useLogBook(patientId);
  const finalData = data ? dataFilterListTable(data, filterChoice) : [];

  const ModalClick = (item) => {
    setModalData(item);
    modalRef.current.open();
  };

  const loader = () => {
    return (
        <div className={classes.wrapper}>
          <Button className={classes.waiting}
                  disabled={!hasNextPage || isFetchingNextPage}
                  onClick={fetchNextPage}
          >
            {isFetchingNextPage
                ? 'در حال گرفتن اطلاعات...'
                : hasNextPage
                    ? 'نمایش بیشتر' : ''}
          </Button>
        </div>
    );
  };

  const endMessage = () => {
    return (
        data?.pages[0]?.length === 0 ?
            <Grid className={classes.noDataContainer} container marginTop='20%'>
              <Grid className={classes.noData} item xs={12}
                    margin='0 auto' display='flex' justifyContent='center' alignItems='center'>
                <img src={noData} alt='no data'/>
              </Grid>
              <Grid className={classes.date} item xs={12} justifyContent='center' alignItems='center'
                    display='flex'>
                <p style={
                  {textAlign: 'center', fontSize: '18px',paddingTop:'20px'}
                }>
                  تستی برای نمایش وجود ندارد!</p>
              </Grid>
            </Grid> : (!isLoading && !isFetching) ?
                <p className={classes.endMessage}>
                  <b>لیست نتایج شما به پایان رسید!</b>
                </p> : ''
    );
  };

  return (
      <>
        <BackToTopButton listTable/>
        <InfiniteScroll
            next={fetchNextPage}
            dataLength={data ? data?.pages.length * 20 : 20}
            hasMore={hasNextPage}
            scrollThreshold={0.9}
            style={{
              paddingBottom: '30px', overflow: 'hidden',
              backgroundColor: 'transparent'
            }}
            loader={loader()}
            endMessage={endMessage()}
        >
          {isLoading ? <Loading
                  style={{ margin: '40% auto 0', display: 'flex',
                  justifyContent: 'center',height: '90px', width: '90px'}}/> :
              <Grid container>
                <Modal ref={modalRef} data={ModalData} direction='row-reverse'/>
                {finalData?.pages?.map((page) => {
                  return (
                      <React.Fragment key={page.nextId}>
                        {page?.map((glucoseCard, index) => {
                          const destructureData = destructureDataForModalCards(glucoseCard);
                          return (
                              <Grid container justifyContent='center' key={index}>
                                <ListDateTitle page={page} index={index}/>
                                <Grid
                                    item
                                    xs={11}
                                    mb='16px'
                                    onClick={() => ModalClick(destructureData)}
                                >
                                  <Card cardData={destructureData}/>
                                </Grid>
                              </Grid>)
                        })}
                      </React.Fragment>
                  )
                })}
              </Grid>}
        </InfiniteScroll>
      </>


  );
}
